import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildAuthHeaders, getCentralApiBaseUrl } from "./apiBase";

const centralBaseUrl = getCentralApiBaseUrl();

const buildCashingUpReportQuery = (path, { storeId, businessDate, tillId, statuses, limit } = {}) => {
  const params = new URLSearchParams();
  if (storeId) params.append("storeId", storeId);
  if (businessDate) params.append("businessDate", businessDate);
  if (tillId) params.append("tillId", tillId);
  if (statuses) params.append("statuses", statuses);
  if (limit !== undefined && limit !== null && limit !== "") {
    params.append("limit", String(limit));
  }
  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
};

export const centralApi = createApi({
  reducerPath: "centralApi",
  baseQuery: fetchBaseQuery({
    baseUrl: centralBaseUrl,
    prepareHeaders: (headers, api) => buildAuthHeaders(headers, api?.getState),
  }),
  tagTypes: ["CashingUpReport"],
  endpoints: (builder) => ({
    getCashingUpSessionsReport: builder.query({
      query: (params) =>
        buildCashingUpReportQuery("/api/reports/cashing-up/sessions", params),
      providesTags: ["CashingUpReport"],
    }),
    getCashingUpVariancesReport: builder.query({
      query: (params) =>
        buildCashingUpReportQuery("/api/reports/cashing-up/variances", params),
      providesTags: ["CashingUpReport"],
    }),
    getCashingUpPaidOutsReport: builder.query({
      query: (params) =>
        buildCashingUpReportQuery("/api/reports/cashing-up/paid-outs", params),
      providesTags: ["CashingUpReport"],
    }),
    getCashingUpDayClosesReport: builder.query({
      query: (params) =>
        buildCashingUpReportQuery("/api/reports/cashing-up/day-closes", params),
      providesTags: ["CashingUpReport"],
    }),
    exportCashingUpReport: builder.mutation({
      query: (params) => ({
        url: buildCashingUpReportQuery("/api/reports/cashing-up/export", params),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetCashingUpSessionsReportQuery,
  useGetCashingUpVariancesReportQuery,
  useGetCashingUpPaidOutsReportQuery,
  useGetCashingUpDayClosesReportQuery,
  useExportCashingUpReportMutation,
} = centralApi;
